import React from 'react';

import { object } from 'prop-types';

import { ListItem, Link, SvgList, FacebookIcon, InstagramIcon, YouTubeIcon, BlogSvg } from './styles';

const BlogIcon = () => (
  <BlogSvg>
    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/ecommerce.svg#icon-social-blog" />
  </BlogSvg>
);

const FooterSocials = ({ facebook, instagram, youtube, blog }) => (
  <SvgList>
    {facebook && (
      <ListItem key={facebook.title}>
        <Link href={facebook.link} title={facebook.title} rel="noopener" target="_blank">
          <FacebookIcon />
        </Link>
      </ListItem>
    )}
    {instagram && (
      <ListItem key={instagram.title}>
        <Link href={instagram.link} title={instagram.title} rel="noopener" target="_blank">
          <InstagramIcon />
        </Link>
      </ListItem>
    )}
    {youtube && (
      <ListItem key={youtube.title}>
        <Link href={youtube.link} title={youtube.title} rel="noopener" target="_blank">
          <YouTubeIcon />
        </Link>
      </ListItem>
    )}
    {blog && (
      <ListItem key={blog.title}>
        <Link href={blog.link} title={blog.title} rel="noopener" target="_blank">
          <BlogSvg>
            <BlogIcon />
          </BlogSvg>
        </Link>
      </ListItem>
    )}
  </SvgList>
);

FooterSocials.propTypes = {
  facebook: object,
  instagram: object,
  youtube: object,
  blog: object,
};

export default FooterSocials;
